import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  id: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  onClick: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string,
  classList: PropTypes.string,
  isDisabled: PropTypes.bool,
  isOpen: PropTypes.bool,
  placeholder: PropTypes.string
};
function MenuButton(_ref) {
  var _ref$buttonLabel = _ref.buttonLabel,
    buttonLabel = _ref$buttonLabel === void 0 ? null : _ref$buttonLabel,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    id = _ref.id,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    menuItems = _ref.menuItems,
    onClick = _ref.onClick,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "menu-button ".concat(classList),
    "data-testid": "menu-button"
  }, /*#__PURE__*/React__default.createElement("button", {
    "aria-controls": "list-menu-".concat(id),
    "aria-expanded": !isOpen ? 'false' : 'true',
    "aria-haspopup": "menu",
    "data-filled": !!buttonLabel,
    disabled: isDisabled,
    id: id,
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "button-text"
  }, buttonLabel), /*#__PURE__*/React__default.createElement("span", {
    className: "placeholder",
    "aria-hidden": "false"
  }, placeholder), /*#__PURE__*/React__default.createElement("span", {
    className: "arrow-icon"
  })), /*#__PURE__*/React__default.createElement("label", {
    className: "float-label",
    htmlFor: id,
    "aria-hidden": "false"
  }, placeholder), /*#__PURE__*/React__default.createElement("ul", {
    className: "list-menu",
    id: "list-menu-".concat(id),
    role: "menu",
    "aria-hidden": isOpen ? 'false' : 'true'
  }, menuItems.map(function (menuItem) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: menuItem.label
    }, /*#__PURE__*/React__default.createElement("a", {
      className: "list-menu-option-link",
      role: "menuitem",
      tabIndex: "-1",
      href: menuItem.href
    }, menuItem.label));
  })));
}
MenuButton.propTypes = propTypes;

export { MenuButton as default };
//# sourceMappingURL=MenuButton.js.map
